
/* used for seal subscription don't touch it */
$(document).ready(function(){
  // console.log(`__shopMoneyFormat = ${__shopMoneyFormat}`);
  if (typeof window.SealSubs !== 'undefined' && typeof window.SealSubs.refresh === 'function') {
  	window.SealSubs.refresh();
   
    console.log('if refresh')
  }else{
    console.log('else refresh')
  }

  // if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.getBundles === 'function') {
  // 	var bundles = window.bndlr.getBundles();
  // 	// Do your magic with bundles :) 
  //   console.log('if bundles')
  //   console.log(bundles)
  // }else{
  //   console.log('else bundles')
  // }
   setTimeout(function(){
      manageAddToCartButton()
   },500);
  
});

function sealSubscriptionManaging(){
  let parentFrm = $("form.sealSubcriptionForm");
  let plan = parentFrm.find(".sealsubs-target-element.sealsubs-full input[type=radio].sls-option:checked").val();
  
  console.log(`plan = ${plan}`);
  /* Check either subcription or not*/
  if(plan == 'one_time'){
    $(parentFrm).find(".spProductBlock.spActive").each(function(){
        $(this).find('input.addJsInput.sealSubscProp').attr('name', '');
    });
  }else{
   
    /*let subsInterval = parentFrm.find('select[name=subs_interval]').val();
    
    let sealSubsIntervalHiddenVal  = parentFrm.find('input[name="properties[Subscription interval]"]').val();
    let sealSubsIntervalHiddenAttr = parentFrm.find('.sls-cart-attribute.sls-hidden.sls-input-interval').attr('name');
    let sealSubRuleidHiddenAttr    = parentFrm.find('.sls-cart-attribute.sls-hidden.sls-input-id').attr('name');

    console.log("attribute " + sealSubsIntervalHiddenAttr)

    // Extract the desired word within square brackets
    let sealSubsIntervalHiddenAttrMatch = /\[(.*?)\]/.exec(sealSubsIntervalHiddenAttr);
    sealSubsIntervalHiddenAttr = sealSubsIntervalHiddenAttrMatch && sealSubsIntervalHiddenAttrMatch[1] ? sealSubsIntervalHiddenAttrMatch[1] : '';
    
    let sealSubRuleidHiddenAttrMatch = /\[(.*?)\]/.exec(sealSubRuleidHiddenAttr);
    sealSubRuleidHiddenAttr = sealSubRuleidHiddenAttrMatch && sealSubRuleidHiddenAttrMatch[1] ? sealSubRuleidHiddenAttrMatch[1] : '';
    
    let dataItem = $(this).data('item')
    $(this).find("input.sp-sls-input-subscription-visible").val(sealSubsIntervalHiddenVal);
    $(this).find("input.sp-sls-input-interval").attr('name', `items[${dataItem}][properties][${sealSubsIntervalHiddenAttr}]`);
    $(this).find("input.sp-sls-input-id").attr('name', `items[${dataItem}][properties][${sealSubRuleidHiddenAttr}]`);*/ 
  
    
    $(parentFrm).find(".spProductBlock.spActive").each(function(){
        var dataItem = $(this).data('item')
        var spProductBlockActiveThis = $(this);
        
        $('.sls-option-container.seal-table.sls-active .sls-cart-attribute.sls-hidden').each(function(index) {
          
          let $clone = $(this).clone();
          let classAttr = $(this).attr('class');
          let classSelector =  classAttr.replace(/ /g,".");
          console.log(`classSelector = ${classSelector}`)
          // Check if a clone with the same value already exists in newDiv
          if (!spProductBlockActiveThis.find(classSelector).length) {
            /* adding our required class */
            $clone.addClass("addJsInput sealSubscProp")
  
            /* change the name attribute value of clone */
            let sealAttributeNameValue    = $(this).attr('name');
            let sealAttributeNameValueMatch = /\[(.*?)\]/.exec(sealAttributeNameValue);
            multiSealAttributeNameValue = sealAttributeNameValueMatch && sealAttributeNameValueMatch[1] ? sealAttributeNameValueMatch[1] : '';
            $clone.attr('name', `items[${dataItem}][properties][${multiSealAttributeNameValue}]`);
            $clone.val($(this).val());
  
            spProductBlockActiveThis.prepend($clone);
          }
        });
      // $(this).find('input.addJsInput.sealSubscProp').each(function () {
      //   // Get the data-name attribute value
      //   var dataName = $(this).data('name');
      //   console.log(`dataName = ${dataName}` )
      //   // Add the name to the child element
      //   $(this).attr('name', dataName);
      // });
    });
  }
}

function manageAddToCartButton(){
  let parentFrm = $("form.sealSubcriptionForm");
  let productSelected = $(parentFrm).find(".spProductBlock.spActive").length

  if(parseInt(productSelected) >= 1){
    $(".sealsubs-container").addClass('active');
    $("#addSubcrBtn").removeClass('disabeld').removeAttr('disabled');
  }else{
    $(".sealsubs-container").removeClass('active');
    $("#addSubcrBtn").addClass('disabeld').attr('disabled', 'true')
  }

  let plan = parentFrm.find(".sealsubs-target-element.sealsubs-full input[type=radio].sls-option:checked").val();

  if(plan == 'one_time'){
    $("#addSubcrBtn").find("span.btnName").text('ADD TO CART');
  }else{
    $("#addSubcrBtn").find("span.btnName").text('SUBSCRIBE');
  }
}
  
$(document).on('click', '.spAddBtn', function(){
  $(this).hide();
  let parent = $(this).closest("div.spProductBlock");
  
  parent.addClass('spActive');
  // Loop through each child element

  parent.find('input.addJsInput.shopifyProductFrm').each(function () {
    // Get the data-name attribute value
    var dataName = $(this).data('name');
    console.log(`dataName = ${dataName}` )
    // Add the name to the child element
    $(this).attr('name', dataName);
  });
  sealSubscriptionManaging();
  manageAddToCartButton();
  countCartPrice();
});

$(document).on('click', '.plusBtn', function(){
  countCartPrice();
});
$(document).on('click', '.minusBtn', function(){
  let parent = $(this).closest("div.spProductBlock");
  qtyValue = parent.find('.spQtyBox').val();
  if(parseInt(qtyValue) <= 1){
    parent.find('.spAddBtn').show();
    parent.removeClass('spActive');
    parent.find('input.addJsInput').attr('name', '');
    parent.find('input.addJsInput.sealSubscProp').remove();
  }
  manageAddToCartButton();
  countCartPrice();
});

$(document).on('change', '.spQtyBox', function(){
  let currentQty = $(this).val();
  let parent = $(this).closest("div.spProductBlock");
  parent.find('.spQtyBoxBind').val(currentQty);
});

/* called when some once change the plan in between subscription & one time */
$(document).on('click', '.sealsubs-target-element.sealsubs-full input[type=radio].sls-option, .sls-label-container.seal-col label', function(){
  console.log("on plan changed called");
  sealSubscriptionManaging();
  setTimeout(function(){
    manageAddToCartButton();
    countCartPrice();
  },100)
});

/* called when some once change the subscription interval like every week, every 2 week, every month ...etc */
$(document).on('change', 'select[name=subs_interval]', function(){
  setTimeout(function(){
    sealSubscriptionManaging();
  },300)
});

function countCartPrice(){
  let parentFrm = $("form.sealSubcriptionForm");
  let selectedProducts = $(parentFrm).find(".spProductBlock.spActive").length;
  selectedProducts = (typeof selectedProducts != 'undefined' && selectedProducts != '')? parseInt(selectedProducts):0;
  
  let plan = parentFrm.find(".sealsubs-target-element.sealsubs-full input[type=radio].sls-option:checked").val();
  
  console.log(`plan = ${plan}`);
  /* Check either subcription or not*/
  if(selectedProducts == 0){
    parentFrm.find("#amtDivBlock").css('visibility', 'hidden')
  }else{
    
    let sealDiscountAttr  = parentFrm.find('.sls-input-discount-value').attr('name');
    let sealDiscountAttrMatch = /\[(.*?)\]/.exec(sealDiscountAttr);
    
    sealDiscountAttr = sealDiscountAttrMatch && sealDiscountAttrMatch[1] ? sealDiscountAttrMatch[1] : '';
    sealDiscount = sealDiscountAttr.replace("_sealsub_discount_", "");
    console.log(`sealDiscount = ${sealDiscount}`);
    sealDiscount = (typeof sealDiscount != 'undefined' && sealDiscount != '')? parseFloat(sealDiscount.replace("%", "")):0;
    
      // parentFrm.find("sls-cart-attribute.sls-hidden.sls-input-discount-value").val(sealSubsIntervalHiddenVal);
  
    var totalPrice = 0
    $(parentFrm).find(".spProductBlock.spActive").each(function(){
      let productPrice = $(this).data('price')
      let qty = $(this).find(".spQtyBoxBind").val();
  
      productPrice = (typeof productPrice != 'undefined' && productPrice != '')? parseInt(productPrice):0;
      qty = (typeof qty != 'undefined' && qty != '')? parseInt(qty):1;
      
      totalPrice += (productPrice * qty);
    });
  
    let savingAmt = (totalPrice * (sealDiscount/100));
    let totalPayableAmt = totalPrice - savingAmt;
    
    let savingAmtFormated = ChFormatMoney(savingAmt, __shopMoneyFormat);
    let totalPriceFromated = ChFormatMoney(totalPrice, __shopMoneyFormat);
    let totalPayableAmtFromated = ChFormatMoney(totalPayableAmt, __shopMoneyFormat);
    
    if(plan == 'one_time'){
      parentFrm.find("div.actions-total #savingAmt").css('visibility', 'hidden').text('')
      parentFrm.find("div.actions-total #totalAmt").css('visibility', 'hidden').text('')
      parentFrm.find("div.actions-total #totalPayableAmt").text(totalPayableAmtFromated)
    }else{
      if(savingAmt > 0){
        parentFrm.find("div.actions-total #savingAmt").text(`You’re SAVING ${savingAmtFormated}`).css('visibility', 'visible')
        parentFrm.find("div.actions-total #totalAmt").text(totalPriceFromated).css('visibility', 'visible')
      }
      parentFrm.find("div.actions-total #totalPayableAmt").text(totalPayableAmtFromated)  
    }
    parentFrm.find("#amtDivBlock").css('visibility', 'visible')
  }
}

var ChFormatMoney = function (cents, ch_currency) {
    var format = ch_currency;
    if (typeof cents == "undefined" || cents == null) {
        return "";
    }
    if (typeof cents == "string" && cents.length == 0) {
        return "";
    }

    var value = "",
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || this.money_format;
    if (typeof cents == "string") {
        cents = cents.replace(".", "");
    }

    function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);
        var parts = number.split("."),
            dollars = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, ".", "");
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, ",", "");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
    }
    return formatString.replace(placeholderRegex, value);
};